(function () {
  'use strict';

  // Global delegated listener: fires tour_booked ($100) for any click on an
  // anchor pointing at calendly.com, anywhere on the site. Complements the
  // calendly-cta snippet handler so plain <a href> links (e.g. home-quote-cta)
  // also count. Dedupes per pageview via window._trTourBookedFired.

  function isCalendlyHref(href) {
    if (!href) return false;
    return href.indexOf('calendly.com') !== -1;
  }

  function fireTourBooked(href, source) {
    if (window._trTourBookedFired) return;
    if (typeof window.gtag !== 'function') return;
    window._trTourBookedFired = true;
    window.gtag('event', 'tour_booked', {
      value: 100,
      currency: 'USD',
      source: source || 'tour_link_click',
      source_page: window.location.pathname,
      destination: href || ''
    });
  }

  document.addEventListener('click', function (e) {
    var node = e.target;
    var anchor = null;
    while (node && node !== document) {
      if (node.tagName === 'A') { anchor = node; break; }
      node = node.parentNode;
    }
    if (!anchor) return;
    if (!isCalendlyHref(anchor.getAttribute('href'))) return;
    fireTourBooked(anchor.getAttribute('href'), 'tour_link_click');
  }, true);
})();
